













































import {asArray, forEach, isArray, isBool, isEmpty, isUndefined} from '@labor-digital/helferlein';
import {CheckboxInputs} from '../Checkbox/Checkbox.interfaces';

/**
 * @deprecated use BaseRadio instead
 */
export default {
    name: 'RadioButton',
    props: {
        /**
         * set group name to group radio buttons
         */
        groupName: {
            type: String,
            required: true
        },
        /**
         * parse checkboxes as array
         */
        items: Array,
        /**
         * choose label side right or left
         */
        labelSide: {
            default: 'right',
            type: String,
            validate: (v) => {
                return ['left', 'right'].indexOf(v) !== -1;
            }
        },
        /**
         * set error message in span
         * css class: radio__error
         */
        error: {
            type: String
        },

        value: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        prepareItems()
        {
            let preparedItems = [];

            // Build a unique value map
            const value = isArray(this.value) ? this.value : [];
            const items = isArray(this.items) ? this.items : [];
            const newValueMap = new Map();
            const selectedItemValues = [];
            forEach(value, (item: CheckboxInputs) => {
                selectedItemValues.push(item.value);
                newValueMap.set(item.value, item);
            });

            // Build the prepared item list
            forEach(items, (item) => {
                const value = item.value ?? item;
                const _item = {
                    value,
                    label: item.label ?? item,
                    checked: isBool(item.checked) ? item.checked :
                        selectedItemValues.indexOf(value) !== -1,
                    required: item.required ?? false,
                    disabled: item.disabled ?? false,
                    show: item.show ?? true,
                    classes: item.classes ?? {}
                };
                if (_item.checked) {
                    newValueMap.set(value, _item);
                } else {
                    newValueMap.delete(value);
                }
                preparedItems.push(_item);
            });

            // Emit the input event after an update
            // We need this here for baseSelectBox -> So don't delete it
            if (JSON.stringify(asArray(newValueMap.keys())) !== JSON.stringify(selectedItemValues)) {
                this.$emit('input', asArray(newValueMap));
            }
            return preparedItems;
        },
        hasCustomRadioIcon(): boolean
        {
            return isEmpty(this.$slots.customRadioIcon);
        },
        hasError(): boolean
        {
            return !isEmpty(this.$slots.error) || !isEmpty(this.error);
        }
    },
    methods: {
        hasItems()
        {
            return !isEmpty(this.items) || !isUndefined(this.items);
        },
        hasLabel(v): boolean
        {
            return isUndefined(v.label) || isEmpty(v.label) ? v : v.label;
        },
        intClasses(item)
        {
            return {
                ...item.classes,
                'radioButton__label--required': item.required,
                'radioButton__label--disabled': item.disabled,
                'radioButton__label--checked': item.checked
            };
        },
        updateValue(item, e)
        {
            item.checked = e.target.checked;
            let valueClone = isArray(this.value) ? [...this.value] : [];
            valueClone = [item];
            this.$emit('input', valueClone);
        }
    }
};
